import { FiltersValueKey, CityLedgerFilterValues } from './schema';

export const useDefaultFilterValues = (): CityLedgerFilterValues => ({
    [FiltersValueKey.searchQuery]: '',
    [FiltersValueKey.ownerTypes]: [],
    [FiltersValueKey.invoiceStatus]: [],
    [FiltersValueKey.balanceMin]: 0,
    [FiltersValueKey.balanceMax]: 0,
    [FiltersValueKey.ageing]: [],
});
